// extracted by mini-css-extract-plugin
export default {"list_wrapper":"CreatePurchaseOrderModal_list_wrapper__x7isJ","label":"CreatePurchaseOrderModal_label__js0hr","addBtn":"CreatePurchaseOrderModal_addBtn__meD1j"};